const SET_INCLUDE_CASH = 'SET_INCLUDE_CASH';

export { SET_INCLUDE_CASH };



// WEBPACK FOOTER //
// ./src/containers/common/cash/constants.js